var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"fl-header"},[_c('div',[_c('fl-logo',{staticClass:"fl-header__logo",on:{"click":_vm.goToMain}}),_c('ui-icon',{staticClass:"fl-header__icon",attrs:{"name":"uiBars","size":25},on:{"click":_vm.toggleMobileMenu}})],1),_c('fl-header-profile')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }